export default __webpack_public_path__ + "static/media/Ranking-Poll.12dfed7e.gif";